import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import ShopForm from "../../components/Admin/forms/ShopForm";
import CommonContainer from "../../components/common/container/CommonContainer";
import useSnackbarAlert from "../../utils/snackbarHandlers";

const initialData = {
    fullName: "",
    address: "",
    logo: "",
    subscriptionPlan: " ",
    email: "",
    phone: "",
    paymentStatus: " ",
    storename: "",
    ticketslocation: " ",
    nextSubscriptionDate: "",
  };

const CreateShop: React.FC = () => {
  const { t } = useTranslation("translation");
  const [loading, setLoading] = React.useState(false);
  const [logo, setLogo] = React.useState<string>("");
  const navigate = useNavigate();
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";

  const onHandleSubmit = (value: any) => {
    setLoading(true);
    const fileHeaders = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "multipart/form-data",
    };
    const body = {
      fullName: value?.fullName,
      address: value?.address,
      logo: value?.logo,
      subscriptionPlan: value?.subscriptionPlan,
      email: value?.email,
      phone: value?.phone,
      storename: value?.storename,
      ticketslocation: value?.ticketslocation,
      nextSubscriptionDate: value?.nextSubscriptionDate,
      paymentStatus: value?.paymentStatus
    };

    axios
      .post(`${apiBaseURL}/api/shop/addShop`, body, { headers: fileHeaders })
      .then((data: any) => {
        if (data?.status == 200) {
          showSuccessMessage(t("shopAddSuccessfullMessage", "Shop Added Successfully"))
          navigate('/admin/shopList');
        }
      })
      .catch((err: any) => {
        console.log("err", err);
        showErrorMessage(t("somethingWentWrong"))
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
      <CommonContainer title={t("createShop")} description={t("createShopPageDescription")} backButtonurl= "/admin/shopList">
        <ShopForm
            data={initialData}
            onFormSubmit={(values) => onHandleSubmit(values)}
            loading={loading}
            logo={logo}
            setLogo={setLogo}
        />
      </CommonContainer>
  );
};

export default CreateShop;
